import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { VFlex, VInput } from '@/package';

import TaskCreateFormSelectPathButton from './TaskCreateFormSelectPathButton';
import type { TaskCreateFormType } from './type';

export const TaskPath = ({ readOnly }: { readOnly: boolean }) => {
  const { t } = useTranslation();
  const {
    watch,
    setValue,
    register,
    getValues,
    formState: { touchedFields },
  } = useFormContext<TaskCreateFormType>();
  const basePath = watch('basePath');
  const orgPath = watch('orgPath');

  const validatePath = () => {
    const currentBasePath = getValues('basePath');
    const currentOrgPath = getValues('orgPath');
    return Boolean(currentBasePath || currentOrgPath);
  };

  return (
    <VFlex items="center" gap={1} className="w-full">
      <VInput
        fluid
        required
        label={t('task.createTaskFolderLabel.oscular')}
        placeholder={t('task.createTaskFloderPlaceholder.leucotoxic')}
        value={
          basePath || orgPath
            ? `${basePath ?? ''}${orgPath ?? ''}`.replace(/\/+/, '/')
            : ''
        }
        readOnly
        {...register('orgPath', {
          validate: validatePath,
        })}
        valid={!touchedFields.orgPath || validatePath()}
      />
      {!readOnly && (
        <TaskCreateFormSelectPathButton
          onSelect={({ basePath, orgPath }) => {
            setValue('basePath', basePath, { shouldValidate: true });
            setValue('orgPath', orgPath, { shouldValidate: true });
          }}
        />
      )}
    </VFlex>
  );
};
